







































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import DropdownTransition from './DropdownTransition.vue'

@Component({
  components: {
    DropdownTransition,
  },
})
export default class Dropdown extends Vue {

  @Prop({ default: undefined })
  href: string

  @Prop()
  children: any[]

  open: boolean = false

  toggle() {
    if (this.isChildren) {
      this.open = !this.open
    }
  }

  get isChildren() {
    return this.children && this.children.length
  }

  get isHref() {
    return this.href !== undefined
  }

  get status() {
    if (!this.isChildren) {
      return ''
    }

    return this.open ? 'fa-chevron-down show' : 'fa-chevron-down'
  }
}
